import React, { PropTypes } from 'react';

class FeedbackRadios extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string
  };

  render() {
    return (
      <ul>
        <li>
          <input type="radio" name={this.props.name} value="1" id={"horrible-" + this.props.name} onChange={this.handleChange} />
          <label htmlFor={"horrible-" + this.props.name} className="option horrible"><span className="sr-only">1</span></label>
        </li>
        <li>
          <input type="radio" name={this.props.name} value="2" id={"bad-" + this.props.name} onChange={this.handleChange} />
          <label htmlFor={"bad-" + this.props.name} className="option bad"><span className="sr-only">2</span></label>
        </li>
        <li>
          <input type="radio" name={this.props.name} value="3" id={"neutral" + this.props.name} onChange={this.handleChange} />
          <label htmlFor={"neutral" + this.props.name} className="option neutral"><span className="sr-only">3</span></label>
        </li>
        <li>
          <input type="radio" name={this.props.name} value="4" id={"good-" + this.props.name} onChange={this.handleChange} />
          <label htmlFor={"good-" + this.props.name} className="option good"><span className="sr-only">4</span></label>
        </li>
        <li>
          <input type="radio" name={this.props.name} value="5" id={"great-" + this.props.name} onChange={this.handleChange} />
          <label htmlFor={"great-" + this.props.name} className="option great"><span className="sr-only">5</span></label>
        </li>
      </ul>
    );
  }
}

export default FeedbackRadios;



/** WEBPACK FOOTER **
 ** ./src/components/FeedbackRadios.js
 **/